import QuoteForm from "@/components/site/QuoteForm";
import { MapPin, Phone, Mail, Clock, Globe, Facebook } from "lucide-react";
import { SITE } from "@/lib/site";

const ITEMS = [
  { icon: MapPin, label: "Sede", value: SITE.address },
  { icon: Phone, label: "Telefono", value: SITE.phone, href: `tel:${SITE.phoneTel}` },
  { icon: Mail, label: "Email", value: SITE.email, href: `mailto:${SITE.email}` },
  { icon: Globe, label: "Sito", value: SITE.site, href: `https://${SITE.site}` },
  { icon: Facebook, label: "Facebook", value: "Seguici · @SiciliaTraslochi", href: SITE.facebook },
  { icon: Clock, label: "Orari", value: SITE.hours },
];

export default function Contact() {
  return (
    <section id="contatti" data-testid="contact-section" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div id="preventivo" className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5 reveal">
            <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-bold text-brand-primary">
              <span className="w-8 h-px bg-brand-primary" />
              Parliamone
            </div>
            <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brand-ink mt-4 text-balance">
              Il vostro nuovo<br />capitolo inizia qui.
            </h2>
            <p className="mt-5 text-lg text-brand-body leading-relaxed">
              Compilate il modulo o chiamateci direttamente: <strong className="text-brand-ink">vi rispondiamo entro 60 minuti</strong>.
              Sopralluogo e preventivo sono sempre gratuiti.
            </p>

            <div className="mt-10 space-y-4">
              {ITEMS.map(({ icon: Icon, label, value, href }, i) => {
                const content = (
                  <div className="flex items-start gap-4 group">
                    <div className="w-11 h-11 rounded-xl bg-brand-surface group-hover:bg-brand-primary group-hover:text-white border border-brand-line text-brand-primary flex items-center justify-center transition-all shrink-0">
                      <Icon className="w-5 h-5" />
                    </div>
                    <div>
                      <div className="text-[11px] uppercase tracking-[0.18em] font-bold text-brand-body">{label}</div>
                      <div className="font-display font-bold text-lg text-brand-ink mt-0.5">{value}</div>
                    </div>
                  </div>
                );
                return href ? (
                  <a
                    key={label}
                    href={href}
                    target={href.startsWith("http") ? "_blank" : undefined}
                    rel="noopener noreferrer"
                    data-testid={`contact-item-${i}`}
                    className="block"
                  >
                    {content}
                  </a>
                ) : (
                  <div key={label} data-testid={`contact-item-${i}`}>
                    {content}
                  </div>
                );
              })}
            </div>

            {/* Map */}
            <div className="mt-10 rounded-2xl overflow-hidden border border-brand-line">
              <iframe
                title="Mappa Sicilia Traslochi - Caltanissetta"
                src={`https://www.google.com/maps?q=${encodeURIComponent("Via Colajanni 230, Caltanissetta")}&output=embed`}
                width="100%"
                height="260"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <QuoteForm variant="section" />
          </div>
        </div>
      </div>
    </section>
  );
}
